export interface IBounds {
	left: number;
	right: number;
	top: number;
	bottom: number;
}